<template>
    <div class="modalBG">
        <div class="modalContent">
            <h1 class="modalHeader">{{ header }}</h1>
            <div class="modalBody">
                <p>{{ text }}</p>
            </div>
            <div class="modalButtons">
                <button @click="confirm">확인</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        header: {
            type: String,
            default: '알림',
        },
        text: {
            type: String,
            default: '',
        },
        resolve: {
            type: Function,
            required: true,
        },
    },
    methods: {
        confirm() {
            this.resolve(); // 반환값 없음
            this.$el.remove(); // DOM 제거
        },
    },
};
</script>
<style scoped>
* {
    margin: 0;
}
.modalBG {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.modalContent {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    width: 300px;
    overflow: hidden;
}
.modalHeader {
    font-size: 14px;
    background-color: #1f3559;
    color: #fff;
    padding: 8px;
    font-weight: 500;
}
.modalBody {
    padding: 20px;
    text-align: center;
    font-size: 14px;
}
.modalButtons {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-bottom: 16px;
}
.modalButtons > button {
    all: unset;
    padding: 8px 24px;
    background: #42587e;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}
</style>
